import { render, staticRenderFns } from "./BreadcrumbNav.vue?vue&type=template&id=54938f19&scoped=true"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbNav.vue?vue&type=style&index=0&id=54938f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54938f19",
  null
  
)

export default component.exports